"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const prop_types_1 = __importDefault(require("prop-types"));
const backwardCompatibilityForProperties_1 = require("../../helpers/backwardCompatibilityForProperties");
const DividerConstants_1 = require("./DividerConstants");
require("./Divider.scss");
const Divider = ({ 
// Backward compatibility for props naming
classname, className = undefined, direction = DividerConstants_1.DirectionType.HORIZONTAL }) => {
    const overrideClassName = (0, backwardCompatibilityForProperties_1.backwardCompatibilityForProperties)([className, classname]);
    return (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)("monday-style-divider", overrideClassName, `monday-style-divider--${direction}`) });
};
Divider.directions = DividerConstants_1.DirectionType;
Divider.propTypes = {
    className: prop_types_1.default.string,
    direction: prop_types_1.default.oneOf([Divider.directions.HORIZONTAL, Divider.directions.VERTICAL])
};
exports.default = Divider;
